/* ==========================================================================
   HOFFMANN 16.09.2026 - Warenkorb-Drawer, Steuerung.

   Ersetzt sections/mr-vue-cart.liquid. Kein Framework.

   Aufgabenteilung: Liquid rendert den gesamten Inhalt inklusive Empfehlungen,
   dieses Skript steuert nur Oeffnen, Schliessen und die Aenderungen am Korb.
   Nach jeder Aenderung wird die Section ueber die Section Rendering API neu
   geholt, damit Positionen, Summen, Versandstufe und Empfehlungen aus einer
   einzigen Quelle kommen.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__hfCartBound) return;
  window.__hfCartBound = true;

  /* Die volle Section-ID traegt in Section-Gruppen ein Praefix, etwa
     "sections--32150365339978__hf_cart". Sie wird deshalb zur Laufzeit aus
     dem Markup gelesen, nicht fest verdrahtet. */
  var SECTION_ID = null;
  var STATUS = ['[data-hf-busy]', '[data-hf-error]'];
  var root = null;
  var shell = null;
  var lastFocus = null;
  var busyDepth = 0;
  var undoTimer = null;
  var undoPayload = null;
  var undoNode = null;
  var undoIndex = 0;
  var undoStart = 0;

  /* Jeder Klick auf Plus sofort zu senden hiess: fuenf Anfragen, fuenf
     Neuaufbauten und ein Klick, der waehrend des Ladens ins Leere geht.
     Stattdessen zaehlt die Anzeige sofort hoch und erst nach einer kurzen
     Ruhe geht ein einziger Wert an den Warenkorb. */
  var QTY_CLICK_MS = 420;
  var QTY_TYPE_MS = 800;
  var QTY_MAX = 999;
  var qtyTimers = {};
  var qtyPending = {};

  /* ---------- Hilfen ---------- */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function panel() { return shell ? qs('[data-hf-cart]', shell) : null; }

  function setBusy(on) {
    busyDepth += on ? 1 : -1;
    if (busyDepth < 0) busyDepth = 0;
    var el = shell ? qs('[data-hf-busy]', shell) : null;
    if (el) el.hidden = busyDepth === 0;
  }

  /* Ohne Argument steht die allgemeine Meldung aus den Section-Einstellungen
     da. Mit Argument die genaue, etwa der Bestandshinweis von Shopify. */
  function showError(msg) {
    var el = shell ? qs('[data-hf-error]', shell) : null;
    if (!el) return;
    if (!el.getAttribute('data-hf-fallback')) {
      el.setAttribute('data-hf-fallback', el.textContent);
    }
    el.textContent = msg || el.getAttribute('data-hf-fallback');
    el.hidden = false;
    window.clearTimeout(el.__hfTimer);
    el.__hfTimer = window.setTimeout(function () { el.hidden = true; }, 6000);
  }

  function qtyErrorText() {
    var el = shell ? qs('[data-hf-error]', shell) : null;
    return el ? el.getAttribute('data-hf-qty-error') : null;
  }

  /* ---------- Huelle aufbauen ---------- */

  function build() {
    if (root) return root;

    var section = qs('[data-hf-cart]');
    if (!section) return null;
    SECTION_ID = section.getAttribute('data-section-id') || SECTION_ID;

    root = document.createElement('div');
    root.className = 'hf-cart-root';
    root.setAttribute('hidden', '');

    var veil = document.createElement('div');
    veil.className = 'hf-cart-veil';
    veil.setAttribute('data-hf-cart-veil', '');

    shell = document.createElement('div');
    shell.className = 'hf-cart-shell';

    /* Section-Inhalt in die Huelle umziehen, damit der Drawer ueber allem liegt */
    var inner = section.matches('[data-hf-cart]') ? section : qs('[data-hf-cart]', section);
    if (inner) shell.appendChild(inner);

    /* Ladebalken und Fehlermeldung haengen nicht am Korbinhalt. Sie wandern
       einmalig aus der Section in die Huelle, sonst wuerde jeder
       Neuladevorgang sie ersetzen und ihre Anzeige abbrechen. Die
       Rueckhol-Zeile bleibt bewusst in der Liste, sie gehoert an die Stelle
       der entfernten Position. */
    STATUS.forEach(function (sel) {
      var el = qs(sel, shell);
      if (el) shell.appendChild(el);
    });

    root.appendChild(veil);
    root.appendChild(shell);
    document.body.appendChild(root);
    root.removeAttribute('hidden');

    return root;
  }

  /* ---------- Oeffnen und Schliessen ---------- */

  function focusables() {
    if (!shell) return [];
    return qsa('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', shell)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function trap(event) {
    if (event.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* Liegt die Schnellansicht als Ebene ueber dem Korb, gehoert ihr die
     Tastatur: Escape und Tabulator sollen dort wirken und nicht den Korb
     darunter schliessen. */
  function qvOnTop() {
    return !!document.querySelector('.hf-qv--cart[open]');
  }

  function onKey(event) {
    if (qvOnTop()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    trap(event);
  }

  function open() {
    if (!build()) return;
    if (root.classList.contains('is-open')) return;

    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.classList.add('hf-cart-locked');
    document.addEventListener('keydown', onKey, true);

    window.setTimeout(function () {
      var target = qs('[data-hf-cart-close]', shell);
      if (target) target.focus();
    }, 60);

    document.dispatchEvent(new CustomEvent('hf-cart:open'));
  }

  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    hideUndo();
    root.classList.remove('is-open');
    document.documentElement.classList.remove('hf-cart-locked');
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && document.contains(lastFocus)) {
      try { lastFocus.focus(); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('hf-cart:close'));
  }

  /* ---------- Section neu holen ---------- */

  function refresh() {
    if (!SECTION_ID) {
      var p0 = panel();
      SECTION_ID = p0 ? p0.getAttribute('data-section-id') : null;
    }
    if (!SECTION_ID) return Promise.resolve();
    setBusy(true);
    return fetch(window.location.pathname + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-hf-cart]', doc);
        if (fresh) {
          STATUS.forEach(function (sel) {
            var dup = qs(sel, fresh);
            if (dup && dup.parentNode) dup.parentNode.removeChild(dup);
          });
        }
        var current = panel();
        /* Wer gerade im Mengenfeld steht, soll dort bleiben. */
        var act = document.activeElement;
        var focusKey = null;
        if (act && act.getAttribute && act.hasAttribute('data-hf-qty')) {
          var box = act.closest('[data-hf-stepper]');
          focusKey = box ? box.getAttribute('data-key') : null;
        }
        /* Das frische Markup beginnt oben. Ohne diesen Merker spraenge die
           Liste nach jeder Aenderung an den Anfang und die Rueckhol-Zeile
           einer weiter unten stehenden Position waere nicht mehr zu sehen. */
        var oldList = current ? qs('.hf-cart__list', current) : null;
        var keepTop = oldList ? oldList.scrollTop : 0;
        if (fresh && current && current.parentNode) {
          current.parentNode.replaceChild(fresh, current);
          SECTION_ID = fresh.getAttribute('data-section-id') || SECTION_ID;
          if (keepTop > 0) {
            var newList = qs('.hf-cart__list', fresh);
            if (newList) newList.scrollTop = keepTop;
          }
        }
        /* Wurde waehrend des Ladens weitergeklickt oder getippt, gewinnt die
           Eingabe. Sonst spraenge die Zahl auf den gerade geholten Stand. */
        Object.keys(qtyPending).forEach(function (k) {
          var f = qtyField(k);
          if (f) f.value = qtyPending[k];
        });
        if (focusKey) {
          var back = qtyField(focusKey);
          if (back) {
            back.focus();
            if (back.select) back.select();
          }
        }
        /* Der Austausch des Markups nimmt die Rueckhol-Zeile mit. Laeuft ihr
           Timer noch, kommt sie an derselben Stelle wieder hinein. */
        if (undoPayload) placeUndo();
        syncBubble();
      })
      .catch(function () { showError(); })
      .then(function () { setBusy(false); });
  }

  /* Zaehler am Warenkorbsymbol im Header mitziehen */
  function syncBubble() {
    var p = panel();
    if (!p) return;
    var count = parseInt(p.getAttribute('data-count') || '0', 10);
    qsa('.header__cart-count, [data-cart-count], .cart-count-bubble').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
        el.classList.remove('is-empty');
      } else {
        el.classList.add('is-empty');
      }
    });
  }

  /* ---------- Korb aendern ---------- */

  /* Zwei Schreibvorgaenge gleichzeitig bringen Shopify durcheinander: der
     zweite liest den Korb, waehrend der erste ihn noch umbaut, und bekommt
     "keine gueltigen ID- oder Zeilenparameter" zurueck. Deshalb laeuft jede
     Aenderung erst los, wenn die vorige samt Neuaufbau durch ist. */
  var cartChain = Promise.resolve();

  function inOrder(run) {
    var next = cartChain.then(run, run);
    cartChain = next.catch(function () {});
    return next;
  }

  function changeLine(key, quantity) {
    return inOrder(function () { return sendChange(key, quantity); });
  }

  function sendChange(key, quantity) {
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            /* 422 sind Regelfaelle, etwa ein erschoepfter Bestand. Diesen Text
               schreibt Shopify in der Sprache des Shops, er darf so stehen
               bleiben. 400 und alles andere sind technische Meldungen, dafuer
               ist die allgemeine Zeile die bessere Auskunft. */
            var e = new Error('change failed');
            e.hfText = r.status === 422 ? (data && (data.description || data.message) || '') : '';
            throw e;
          }
          return data;
        });
      })
      .then(function () {
        setBusy(false);
        return refresh();
      })
      .catch(function (err) {
        setBusy(false);
        showError(err && err.hfText ? err.hfText : null);
        /* Zurueck auf den echten Stand, sonst bliebe die abgelehnte Zahl stehen */
        return refresh();
      });
  }

  function addVariant(id, quantity, attrs) {
    return inOrder(function () { return sendAdd(id, quantity, attrs); });
  }

  function sendAdd(id, quantity, attrs) {
    var body = { items: [{ id: Number(id), quantity: quantity || 1 }] };
    setBusy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (attrs) return markAttribute(attrs);
      })
      .then(function () {
        setBusy(false);
        return refresh();
      })
      .catch(function () {
        setBusy(false);
        showError();
      });
  }

  /* Messung: Bestellattribut setzen, wenn aus dem Warenkorb heraus ergaenzt wurde */
  function markAttribute() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { 'Empfehlung genutzt': 'ja' } })
    }).catch(function () {});
  }

  /* ---------- Mengen ---------- */

  function qtyField(key) {
    var p = panel();
    if (!p) return null;
    var box = qs('[data-hf-stepper][data-key="' + key + '"]', p);
    return box ? qs('[data-hf-qty]', box) : null;
  }

  function qtyKey(field) {
    var box = field.closest('[data-hf-stepper]');
    return box ? box.getAttribute('data-key') : null;
  }

  function clearQty(key) {
    window.clearTimeout(qtyTimers[key]);
    delete qtyTimers[key];
    delete qtyPending[key];
  }

  function sendQty(key, value, field) {
    clearQty(key);
    /* Lief zwischendurch ein Neuaufbau, zeigt field auf ein abgehaengtes
       Element. Das frische aus dem aktuellen Markup ist das richtige. */
    var live = qtyField(key);
    /* Ist die Position inzwischen weg, liefe die Aenderung ins Leere und
       Shopify antwortete mit "keine gueltigen ID- oder Zeilenparameter". */
    if (!live) return;
    field = live;
    /* Ab hier gilt der Wert als gesetzt. Enter ruft blur auf, blur ruft
       commitQty auf - ohne diesen Merker ginge dieselbe Menge zweimal raus. */
    if (field) field.setAttribute('data-start', String(value));
    if (value < 1) {
      var row = field ? field.closest('.hf-cart__item') : null;
      var rmBtn = row ? qs('[data-hf-remove]', row) : null;
      offerUndo(key, 1, rmBtn ? rmBtn.getAttribute('data-title') : '', row);
    }
    changeLine(key, value);
  }

  function planQty(key, value, field, delay) {
    qtyPending[key] = value;
    window.clearTimeout(qtyTimers[key]);
    qtyTimers[key] = window.setTimeout(function () {
      sendQty(key, value, field);
    }, delay);
  }

  /* Enter, Verlassen des Feldes und der Ablauf des Timers enden alle hier. */
  function commitQty(field) {
    var key = qtyKey(field);
    if (!key) return;
    var raw = String(field.value).replace(/[^0-9]/g, '');
    if (raw === '' || raw.length > 3) {
      clearQty(key);
      field.value = field.getAttribute('data-start') || '1';
      showError(qtyErrorText());
      return;
    }
    var value = parseInt(raw, 10);
    if (value > QTY_MAX) {
      clearQty(key);
      field.value = field.getAttribute('data-start') || '1';
      showError(qtyErrorText());
      return;
    }
    if (String(value) === String(field.getAttribute('data-start'))) {
      clearQty(key);
      field.value = String(value);
      return;
    }
    sendQty(key, value, field);
  }

  /* ---------- Rueckholen nach dem Entfernen ---------- */

  /* Sieben Sekunden mit sichtbar ablaufendem Balken. Material Design nennt
     fuer Hinweise mit Aktion 4 bis 10 Sekunden; die obere Haelfte ist hier
     richtig, weil die Kundschaft aelter ist und erst lesen muss, was weg ist. */
  var UNDO_MS = 7000;

  function hideUndo() {
    window.clearTimeout(undoTimer);
    undoTimer = null;
    undoPayload = null;
    undoIndex = 0;
    if (undoNode && undoNode.parentNode) undoNode.parentNode.removeChild(undoNode);
    undoNode = null;
  }

  /* Der Balken laeuft ueber eine CSS-Animation. Weil die Zeile nach dem
     Neuladen der Section noch einmal eingesetzt wird, startet die Animation
     dort von vorn. Eine negative Verzoegerung in Hoehe der bereits
     verstrichenen Zeit setzt sie an der richtigen Stelle fort. */
  function runUndoBar() {
    if (!undoNode) return;
    var bar = qs('.hf-cart__undobar', undoNode);
    if (!bar) return;
    var elapsed = Date.now() - undoStart;
    if (elapsed < 0) elapsed = 0;
    bar.style.animation = 'none';
    void bar.offsetWidth; /* Reflow, sonst uebernimmt der Browser den Wechsel nicht */
    bar.style.animation = 'hf-cart-undo ' + (UNDO_MS / 1000) + 's linear ' + (-elapsed / 1000) + 's forwards';
  }

  /* Gemerkt wird, wie viele Positionen vor der Zeile stehen. Damit findet
     sie im frischen Markup ihren alten Platz wieder. */
  function noteUndoIndex() {
    undoIndex = 0;
    var prev = undoNode ? undoNode.previousElementSibling : null;
    while (prev) {
      if (prev.classList.contains('hf-cart__item')) undoIndex += 1;
      prev = prev.previousElementSibling;
    }
  }

  function placeUndo() {
    if (!undoNode) return;
    var p = panel();
    if (!p) return;
    var box = qs('.hf-cart__items', p);
    /* War es die letzte Position, gibt es keine Liste mehr. Dann steht die
       Zeile ganz oben im leeren Warenkorb, wo der Blick ohnehin hinfaellt. */
    var wasLast = false;
    if (!box) {
      box = qs('.hf-cart__empty', p);
      wasLast = true;
    }
    if (!box) { hideUndo(); return; }
    undoNode.classList.add('is-placed');
    if (wasLast) {
      box.insertBefore(undoNode, box.firstChild);
    } else {
      var rows = qsa('.hf-cart__item', box);
      if (rows.length > undoIndex) box.insertBefore(undoNode, rows[undoIndex]);
      else box.appendChild(undoNode);
    }
    runUndoBar();
    /* Sicherheitsnetz, falls die gemerkte Blaetterhoehe nicht mehr passt. */
    var list = qs('.hf-cart__list', p);
    if (list) {
      var lr = list.getBoundingClientRect();
      var nr = undoNode.getBoundingClientRect();
      if (nr.bottom > lr.bottom || nr.top < lr.top) {
        undoNode.scrollIntoView({ block: 'nearest' });
      }
    }
  }

  function offerUndo(key, quantity, title, line) {
    var p = panel();
    var tpl = p ? qs('[data-hf-undo-tpl]', p) : null;
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;

    hideUndo();
    undoNode = tpl.content.firstElementChild.cloneNode(true);
    var name = qs('[data-hf-undo-name]', undoNode);
    if (name) name.textContent = title || '';

    /* Bei den gebuendelten Stoffmustern bleibt die Position stehen, es faellt
       ja nur ein Muster daraus weg. Die Zeile setzt sich dann darunter. */
    var samples = line ? line.hasAttribute('data-hf-samples') : false;
    if (line && line.parentNode) {
      if (samples) {
        line.parentNode.insertBefore(undoNode, line.nextSibling);
      } else {
        line.parentNode.insertBefore(undoNode, line);
        line.classList.add('is-removed');
      }
    } else {
      var box = p ? qs('.hf-cart__items', p) : null;
      if (!box) { undoNode = null; return; }
      box.appendChild(undoNode);
    }

    noteUndoIndex();
    undoPayload = { key: key, quantity: quantity };
    undoStart = Date.now();
    runUndoBar();
    undoTimer = window.setTimeout(hideUndo, UNDO_MS);
  }

  /* ---------- Schnellansicht ---------- */

  function openQuickview(url) {
    if (!url) return;

    /* Seit 17.09.2026 legt sich die Schnellansicht als Ebene UEBER den
       Warenkorb, statt ihn zu schliessen. hf-quickview-panel.js stellt dafuer
       window.hfQuickview bereit und baut mit dem Rahmen "cart" ein schmales
       Fenster in Korbbreite, mit Zurueck-Zeile statt "X". Der Weg zurueck
       fuehrt damit immer ueber den Warenkorb. */
    if (window.hfQuickview && window.hfQuickview.open) {
      window.hfQuickview.open(url, null, 'cart');
      return;
    }

    /* Rueckfallweg, falls das Skript der Schnellansicht nicht geladen ist. */
    close();
    window.setTimeout(function () {
      var ghost = document.createElement('button');
      ghost.type = 'button';
      ghost.setAttribute('data-hf-qv-open', url);
      ghost.setAttribute('aria-hidden', 'true');
      ghost.tabIndex = -1;
      ghost.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;';
      document.body.appendChild(ghost);
      ghost.click();
      window.setTimeout(function () {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }, 1500);
    }, 330);
  }

  /* ---------- Auslöser im Dokument ---------- */

  var TRIGGERS = [
    '[aria-controls="mini-cart"]',
    '.header__cart-toggle',
    '.header__icon--cart',
    '.header__icon-wrapper--cart',
    'a[href="/cart"]',
    'a[href$="/cart"]',
    '[data-hf-cart-open]'
  ].join(',');

  document.addEventListener('click', function (event) {
    /* 1. Oeffnen */
    var trigger = event.target.closest(TRIGGERS);
    if (trigger && !trigger.closest('.hf-cart')) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      open();
      return;
    }

    /* 2. Schliessen */
    if (event.target.closest('[data-hf-cart-veil]') || event.target.closest('[data-hf-cart-close]')) {
      event.preventDefault();
      close();
      return;
    }

    if (!shell || !shell.contains(event.target)) return;

    /* 3. Menge */
    var step = event.target.closest('[data-hf-step]');
    if (step) {
      event.preventDefault();
      var stepper = step.closest('[data-hf-stepper]');
      var cell = qs('[data-hf-qty]', stepper);
      var key = stepper.getAttribute('data-key');
      var now = parseInt(String(cell.value).replace(/[^0-9]/g, ''), 10);
      if (isNaN(now)) now = parseInt(cell.getAttribute('data-start'), 10) || 1;
      var next = now + parseInt(step.getAttribute('data-hf-step'), 10);
      if (next > QTY_MAX) next = QTY_MAX;
      /* Die Null nimmt die Position weg. Das soll sofort passieren, damit die
         Rueckhol-Zeile ohne Verzoegerung an ihrer Stelle steht. */
      if (next < 1) {
        cell.value = '0';
        sendQty(key, 0, cell);
      } else {
        cell.value = String(next);
        planQty(key, next, cell, QTY_CLICK_MS);
      }
      return;
    }

    /* 4. Entfernen */
    var rm = event.target.closest('[data-hf-remove]');
    if (rm) {
      event.preventDefault();
      var key = rm.getAttribute('data-key');
      var title = rm.getAttribute('data-title') || '';
      var line = rm.closest('.hf-cart__item');
      var qtyCell = line ? qs('[data-hf-qty]', line) : null;
      var qty = qtyCell ? parseInt(String(qtyCell.value).replace(/[^0-9]/g, ''), 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      /* Stand noch eine Mengenaenderung derselben Position an, ginge sie nach
         dem Entfernen an einen Schluessel, den es nicht mehr gibt. */
      clearQty(key);
      offerUndo(key, qty, title, line);
      changeLine(key, 0);
      return;
    }

    /* 5. Rueckholen */
    if (event.target.closest('[data-hf-undo-btn]')) {
      event.preventDefault();
      if (!undoPayload) return;
      var p = undoPayload;
      hideUndo();
      /* Der Schluessel enthaelt die Varianten-ID vor dem Doppelpunkt */
      var variant = String(p.key).split(':')[0];
      addVariant(variant, p.quantity);
      return;
    }

    /* 6. Rabattcode aufklappen */
    if (event.target.closest('[data-hf-code-toggle]')) {
      event.preventDefault();
      var code = event.target.closest('[data-hf-code]');
      code.classList.add('is-open');
      var input = qs('input', code);
      if (input) input.focus();
      return;
    }

    /* 7. Stoffmuster aufklappen */
    var st = event.target.closest('[data-hf-samples-toggle]');
    if (st) {
      event.preventDefault();
      var list = qs('[data-hf-samples-list]', st.closest('.hf-cart__item'));
      var openNow = list.hidden;
      list.hidden = !openNow;
      st.setAttribute('aria-expanded', String(openNow));
      return;
    }

    /* 8. Empfehlung mit einer Variante */
    var add = event.target.closest('[data-hf-reco-add]');
    if (add) {
      event.preventDefault();
      add.setAttribute('disabled', '');
      addVariant(add.getAttribute('data-variant'), 1, true);
      return;
    }

    /* 9. Empfehlung mit mehreren Varianten: Schnellansicht oeffnen.
          hf-quickview-panel.js horcht in der Capture-Phase auf
          ".hf-qa__bar, .hf-qa__plus, [data-hf-qv-open]" und liest die
          Produkt-URL aus data-hf-qv-open. Wir setzen das Attribut bewusst
          nicht am echten Knopf, sonst wuerde die Schnellansicht aufgehen,
          bevor der Warenkorb geschlossen ist und beide Ebenen laegen
          uebereinander. Stattdessen erst schliessen, dann einen unsichtbaren
          Ausloeser klicken. */
    var opn = event.target.closest('[data-hf-reco-open]');
    if (opn) {
      event.preventDefault();
      openQuickview(opn.getAttribute('data-url'));
      return;
    }
  }, true);

  /* ---------- Eingabe im Mengenfeld ---------- */

  document.addEventListener('input', function (event) {
    var field = event.target.closest ? event.target.closest('[data-hf-qty]') : null;
    if (!field || !shell || !shell.contains(field)) return;
    var clean = String(field.value).replace(/[^0-9]/g, '').slice(0, 3);
    if (clean !== field.value) field.value = clean;
    var key = qtyKey(field);
    if (!key) return;
    /* Ein leeres Feld ist ein Zwischenschritt beim Tippen, noch nichts senden. */
    if (clean === '') {
      window.clearTimeout(qtyTimers[key]);
      return;
    }
    planQty(key, parseInt(clean, 10), field, QTY_TYPE_MS);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var field = event.target.closest ? event.target.closest('[data-hf-qty]') : null;
    if (!field || !shell || !shell.contains(field)) return;
    event.preventDefault();
    commitQty(field);
    field.blur();
  });

  document.addEventListener('focusout', function (event) {
    var field = event.target.closest ? event.target.closest('[data-hf-qty]') : null;
    if (!field || !shell || !shell.contains(field)) return;
    commitQty(field);
  });

  document.addEventListener('focusin', function (event) {
    var field = event.target.closest ? event.target.closest('[data-hf-qty]') : null;
    if (!field || !shell || !shell.contains(field)) return;
    /* Inhalt markieren, dann ersetzt die erste Ziffer die alte Zahl. */
    if (field.select) field.select();
  });

  /* ---------- Nach dem Hinzufuegen von aussen oeffnen ---------- */

  ['cart:refresh', 'cart:updated', 'variant:added'].forEach(function (name) {
    document.addEventListener(name, function () {
      refresh().then(function () { open(); });
    });
  });

  /* Netz fuer Bausteine, die kein Event feuern */
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (href.indexOf('/cart/add') !== -1) {
      result.then(function (res) {
        if (!res || !res.ok) return;
        window.setTimeout(function () {
          refresh().then(function () { open(); });
        }, 80);
      }).catch(function () {});
    }
    return result;
  };

  /* ---------- Wischgeste mobil ---------- */

  function bindGestures() {
    if (!shell) return;
    var startY = 0;
    var delta = 0;
    var active = false;

    shell.addEventListener('touchstart', function (event) {
      active = false;
      if (window.innerWidth >= 1024) return;
      /* Nur Griff und Kopfzeile ziehen das Fenster zu. Fasste die Geste jede
         Beruehrung ab, setzte touchmove bei jedem Blaettern ein transform auf
         die Huelle und die Positionsliste liesse sich nicht mehr bewegen. */
      if (!event.target.closest('.hf-cart__grip, .hf-cart__head')) return;
      if (event.target.closest('button, a')) return;
      active = true;
      startY = event.touches[0].clientY;
      delta = 0;
      shell.style.transition = 'none';
    }, { passive: true });

    shell.addEventListener('touchmove', function (event) {
      if (!active) return;
      delta = event.touches[0].clientY - startY;
      if (delta < 0) delta = 0;
      shell.style.transform = 'translateY(' + delta + 'px)';
    }, { passive: true });

    shell.addEventListener('touchend', function () {
      if (!active) return;
      active = false;
      shell.style.transition = '';
      shell.style.transform = '';
      if (delta > 110) close();
    });
  }

  /* ---------- Start ---------- */

  function boot() {
    build();
    bindGestures();
    syncBubble();
    /* Focals versteckten Mini-Cart stumm schalten, falls er noch gerendert wird */
    var mini = document.getElementById('mini-cart');
    if (mini) mini.setAttribute('aria-hidden', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
